export default "__VITE_ASSET__BAgVObW2__"